/**
 * Helper function for returning a specified truthy value or undefined.
 *
 * This is mainly useful in building up objects where we either want a property or underined based on some setting or logic.
 * @param input something that may be truthy
 * @returns input or undefined
 */
export function truthyOrUndefined<T>(input: T | null): T | undefined {
  if (input) {
    return input;
  }
}
